var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('img',{attrs:{"src":_vm.icon,"alt":""}}):_c('div',{staticClass:"empty"},[_vm._v("---")])}
var staticRenderFns = []

export { render, staticRenderFns }